import chroma from "chroma-js";

export const hexToColor = (
    hex?: string | null,
    defaultColor: string = "03A365"
) => {
    return chroma(hex || defaultColor);
};
